import { useMutation } from '@tanstack/react-query';
import { apiClient } from '../../lib/api-client';
import type { GeneratePlanInput, IssuedDocument } from '../../types/separations';

/**
 * Generación del PDF del plan de pagos (HU-C05) contra `POST /api/v1/documents/plan-pagos`
 * (`.work/payment-plan/feat-26-asesor-generar-pdf/contrato-api.md` §1). Conectado en fix-50: el back
 * recalcula, bloquea con 422 `PLAN_NO_VALIDO` (con `validaciones`) o 409 `SEPARACION_YA_GENERADA`, y
 * en el éxito devuelve el consecutivo y un enlace firmado de descarga (15 min).
 */
export function useGenerarDocumento() {
  return useMutation<IssuedDocument, Error, GeneratePlanInput>({
    mutationFn: (input) => apiClient.documents.generatePaymentPlan(input),
  });
}
